import {DestroyRef, inject, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {DeviceService} from 'src/app/core/entities/device/device.service';
import {APP_ROUTE_PATH} from 'src/app/core/enums';
import {ACCOUNT_ROUTE_PATH} from 'src/app/core/enums/routes/account-route-path.enum';
import {SERVICE_ROUTE_PATH} from 'src/app/core/enums/routes/service-route-path.enum';
import {first} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {PaymentRedirect} from '@features/payment/domain/ports/navigation/redirect.port';

@Injectable({providedIn: 'root'})
export class RefundNavigator implements PaymentRedirect {
  private readonly router = inject(Router);
  private readonly deviceService = inject(DeviceService);
  private readonly destroyRef = inject(DestroyRef);

  goToProductsOrWaiterPage(): void {
    this.deviceService
      .getDevice()
      .pipe(first(), takeUntilDestroyed(this.destroyRef))
      .subscribe((device) => {
        const path = this.resolvePostOperationPath(device?.personal_use);
        const replaceUrl = this.shouldReplaceUrl(device?.personal_use);

        this.router.navigate([path], {replaceUrl});
      });
  }

  goToTicketPage(ticketId: string): void {
    this.router.navigate(
      [`${APP_ROUTE_PATH.service}/${SERVICE_ROUTE_PATH.ticket}/${ticketId}`],
      {replaceUrl: true}
    );
  }

  private resolvePostOperationPath(isPersonalUse?: boolean): string {
    return isPersonalUse ?? true
      ? `${APP_ROUTE_PATH.service}/${SERVICE_ROUTE_PATH.account}/${ACCOUNT_ROUTE_PATH.products}`
      : `/${APP_ROUTE_PATH.serviceConfiguration}`;
  }

  private shouldReplaceUrl(isPersonalUse?: boolean): boolean {
    return !(isPersonalUse ?? true);
  }
}
